import _ from 'lodash';
import { prepareBaseAutoSaveData, resolveAutoSaveSanitizeOptions } from './shared';
import { createJsonConfiguredAutoSaveAdapter } from './jsonAutoSave';

export const createBusinessPrimeAutoSaveAdapter = (fieldDefinitions = {}, autoSaveConfig = null) => createJsonConfiguredAutoSaveAdapter({
    autoSaveConfig: _.cloneDeep(autoSaveConfig || {}),
    fieldDefinitions: _.cloneDeep(fieldDefinitions || {}),
    prepareData(data) {
        return prepareBaseAutoSaveData(data, resolveAutoSaveSanitizeOptions(autoSaveConfig));
    },
});
